import { render, staticRenderFns } from "./ManageAdmins.vue?vue&type=template&id=652c30a4&scoped=true&"
import script from "./ManageAdmins.vue?vue&type=script&lang=js&"
export * from "./ManageAdmins.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=652c30a4&prod&scoped=true&lang=css&"
import style1 from "./ManageAdmins.vue?vue&type=style&index=1&id=652c30a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652c30a4",
  null
  
)

export default component.exports